/*
 * SWA — small progressive enhancements.
 *
 *  1. Clamp long collection descriptions behind a "Read more" toggle so products
 *     sit above the fold, while the full copy stays in the DOM for SEO.
 *  2. Normalise product descriptions that are written as "- " dash lines, so the
 *     stylesheet can render them as a proper spec list. The bullet styling is
 *     gated on the class added here, so with JS off the dashes still read fine.
 */
(function () {
  'use strict';

  var COLLAPSED_MAX = 90; // px — roughly three lines
  var LEADING_DASH = /^\s*[-–—]\s+/;

  function initReadMore() {
    var desc = document.querySelector('.collection-hero__description');
    if (!desc || desc.dataset.swaReadmore === 'true') return;
    if (desc.scrollHeight <= COLLAPSED_MAX + 12) return;

    var host = desc.parentElement;
    if (!host) return;

    desc.dataset.swaReadmore = 'true';
    host.classList.add('swa-expandable');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'swa-readmore';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read more';

    btn.addEventListener('click', function () {
      var open = host.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? 'Show less' : 'Read more';
    });

    desc.insertAdjacentElement('afterend', btn);
  }

  // The dash is not always a direct child: some lines arrive wrapped in
  // <span class="emoji"> or <strong>, so walk to the first non-blank text node.
  function firstTextNode(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return node.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });
    return walker.nextNode();
  }

  function initDescriptionList() {
    var desc = document.querySelector('.product__description');
    if (!desc || desc.dataset.swaList === 'true') return;

    var stripped = 0;

    desc.querySelectorAll(':scope > p').forEach(function (p) {
      var node = firstTextNode(p);
      if (!node || !LEADING_DASH.test(node.nodeValue)) return;

      node.nodeValue = node.nodeValue.replace(LEADING_DASH, '');
      p.classList.add('swa-desc-item');
      stripped++;
    });

    desc.dataset.swaList = 'true';
    if (stripped > 0) desc.classList.add('swa-desc-clean');
  }

  function init() {
    initReadMore();
    initDescriptionList();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Re-run inside the theme editor, where sections re-render.
  document.addEventListener('shopify:section:load', init);
})();